<template>
  <div id="formLogin" class="container w-100 py-5">

    <div class="row justify-content-center-container">

      <!-- COLONNA BACKGROUND (nascosta su mobile) -->
      <div class="col-12 col-lg-4 d-none d-lg-block">
        <div class="h-100 w-100 bg-dark" :style="{
          backgroundImage: 'url(' + backgroundImage + ')',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }">

          <div class="h-100 d-flex justify-content-center align-items-center text-center text-white"
            style="text-shadow: 2px 2px 5px black;">
            <p class="h2 px-4 py-5" style="font-size:30px">{{ titleText }}</p>
          </div>

        </div>
      </div>

      <!-- FORM LOGIN -->
      <div class="col-12 col-lg-4" style="overflow-y:hidden!important">
        <div
          class="h-100 d-flex justify-content-center align-items-center text-center bg-white border-1-gray py-5 formDiv">

          <div class="clearfix my-2 formLogin" id="frontContent">

            <!-- LOGO DINAMICO -->
            <img :src="logoImage" alt="Logo" class="mb-4" style="width:60px">

            <form @submit.prevent="submitLogin" novalidate>

              <!-- USERNAME -->
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <img src="@/assets/loginstart/img/user.png" class="user-icon" />
                  </span>
                </div>
                <input v-model="input.username" class="form-control" :class="{ 'is-invalid': errors.username }"
                  type="text" placeholder="Username" />
              </div>

              <div v-if="errors.username" class="text-danger text-left mb-2"
                style="margin-top:-10px!important;margin-bottom: 0px!important;">
                {{ errors.username }}
              </div>

              <!-- PASSWORD -->
              <div class="input-group mb-3 mt-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <img src="@/assets/loginstart/img/pwd.png" class="password-icon" />
                  </span>
                </div>
                <input v-model="input.password" class="form-control" :class="{ 'is-invalid': errors.password }"
                  type="password" placeholder="Password" ref="currPass" />

                <img @click="showPassword" class="showpwd" src="@/assets/icons8-eye-24.png" />
              </div>

              <div v-if="errors.password" class="text-danger text-left mb-2"
                style="margin-top:-10px!important;margin-bottom: 0px!important;">
                {{ errors.password }}
              </div>

              <!-- BOTTONI -->
              <div class="row mt-4" style="margin-top:-5px!important">

                <div class="col-6 text-left">
                  <button type="button" class="btn btn-square px-4"
                    style="font-size: smaller;color: #38f;border:1px solid #38f" @click="forgotPassword">
                    Password&nbsp;dimenticata?
                  </button>
                </div>

                <div class="col-6 text-right">
                  <button type="submit" class="btn btn-info btn-square px-4">
                    Login
                  </button>
                </div>

              </div>

            </form>
          </div>

        </div>
      </div>

      <div class="col-12 col-lg-12">
        <p class="text-muted text-center my-2 small">
          ©2004-2025 Powered by
          <a href="https://lc-service.it/" target="_blank">LC-Service srl</a>
        </p>
      </div>

      <div v-if="showBackButton" class="col-12 col-lg-12 text-center">
        <img src="@/assets/back-hdtool.png" class="clBtnBack" id="btnBackCareers" title="Indietro"
          @click="$emit('backClick')" />
      </div>

      <div v-if="showRegisterButton" class="col-12 col-lg-12 text-center">
        <div class="clRegistrati" @click="$emit('registerClick')">Registrati</div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "FormLogin",

  props: {
    backgroundImage: { type: String, required: true },
    logoImage: { type: String, required: true },
    titleText: { type: String, default: "eXact Accesso Clienti" },
    showBackButton: { type: Boolean, default: false },
    showRegisterButton: { type: Boolean, default: false }
  },

  data() {
    return {
      input: {
        username: "",
        password: "",
      },

      errors: {
        username: null,
        password: null,
      }
    };
  },

  methods: {

    showPassword() {
      const field = this.$refs.currPass;
      field.type = field.type === "password" ? "text" : "password";
    },

    validate() {
      this.errors = { username: null, password: null };

      if (!this.input.username.trim()) this.errors.username = "Valore richiesto";
      if (!this.input.password.trim()) this.errors.password = "Valore richiesto";

      return !this.errors.username && !this.errors.password;
    },

    submitLogin() {
      if (!this.validate()) return;
      this.$emit("login", { ...this.input });
    },

    forgotPassword() {
      this.$emit("forgotPassword", this.input.username);
    }
  }
};
</script>

<style>
#formLogin {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}


#formLogin .row.justify-content-center-container {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
}


#formLogin .row {
  display: -ms-flexbox !important;
  display: flex !important;
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
  margin-right: -15px !important;
  margin-left: -15px !important;
}

#formLogin .h-100 {
  min-height: 350px !important;
  height: 350px !important
}

#formLogin .w-100 {
  width: 100% !important;
}

#formLogin .align-items-center {
  -ms-flex-align: center !important;
  align-items: center !important;
}

#formLogin .text-white {
  color: #fff !important;
}

#formLogin .bg-dark {
  background-color: #636f83 !important;
}


#formLogin .row.justify-content-center {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
}


#formLogin a {
  color: #01adff !important;
  text-decoration: none !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

#formLogin .small,
small {
  font-size: 80% !important;
  font-weight: 400 !important;
}

#formLogin .text-muted {
  color: #768192 !important;
  font-size: 12px !important;
}

#formLogin .btn-info {
  color: #fff !important;
  background-color: #39f !important;
  border-color: #39f !important;
}

#formLogin .btn-square {
  border-radius: 0;
}

#formLogin .text-right {
  text-align: right !important;
}

#formLogin .btn {
  display: inline-block;
  font-weight: 400;
  color: #3c4b64;
  text-align: center;
  cursor: pointer;
  background-color: transparent;
  border: 1px solid transparent;
  padding: .375rem .75rem;
  font-size: .875rem;
  line-height: 1.5;
  border-radius: .25rem;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;
}

#formLogin .password-icon,
#formLogin .user-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

#formLogin .form-control {
  width: 100% !important;
  padding: .375rem .75rem !important;
  font-size: .875rem !important;
  border: 1px solid #d8dbe0 !important;
  border-radius: .25rem !important;
}

#formLogin .input-group-text {
  padding: .375rem .75rem !important;
  border: 1px solid #d8dbe0 !important;
  background-color: #ebedef !important;
}

#formLogin .border-1-gray {
  border: 1px solid #aaa;
}

#formLogin .formDiv {
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.5s ease;
}

#backContent {
  position: absolute;
  backface-visibility: hidden;
  transform: rotateY(180deg);
}

#formLogin .formDiv {
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.5s ease;
}

#formLogin .clBtnBack {
  width: 40px;
  cursor: pointer;
  margin-top: 0px !important;
}

#formLogin .clRegistrati {
  font-size: 14px !important;
  cursor: pointer !important;
  font-family: 'Roboto', Arial, Helvetica, sans-serif !important;
  font-weight: bold !important;
}

#formLogin .text-danger {
  color: #dc3545 !important;
}

#formLogin .form-control.is-invalid,
.was-validated .form-control:invalid {
  border-color: #dc3545 !important;
  padding-right: calc(1.5em + .75rem) !important;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat !important;
  background-position: 100% calc(.375em + .1875rem) !important;
  background-size: calc(.75em + .375rem) calc(.75em + .375rem) !important;
}

#formLogin img.showpwd {
  position: absolute;
  top: 9px;
  right: 4px;
  max-width: 22px;
  cursor: pointer;
  z-index: 99999
}
</style>
